module.exports = __webpack_public_path__ + "img/logo.edb7e63c.png";